// project import
import Navigation from './Navigation';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => <Navigation />;

export default DrawerContent;
